export const namespaced = true;

export const state = {
    plots: [],
    plot: {},
    types: [],
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_PLOTS(state, plots) {
        state.plots = plots;
    },
    FETCH_PLOT(state, plot) {
        state.plot = plot;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    ADD_PLOT(state) { },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    PLOTS_REMOVE(state) { },
    PLOTS_BLOCK(state) { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/plots`, {
                params: {
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_PLOTS', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                plot: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchPlot({ commit, state, dispatch }, plot_id) {
        try {
            const res = (await axios.get(`/api/admin/plots/${plot_id}`)).data;
            commit('FETCH_PLOT', res.data.plot);
            return res.data.plot;
        } catch (error) {
            const notification = {
                plot: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
        dispatch('fetch');
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
        dispatch('fetch');
    },

    async block({ commit, state, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-plots`, formDataPost
                    )
                ).data;

                commit('PLOTS_BLOCK');

                dispatch('fetch');

                const notification = {
                    plot: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    plot: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                plot: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-plots`, formDataPost
                    )
                ).data;
                commit('plotS_REMOVE');

                dispatch('fetch');

                const notification = {
                    plot: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    plot: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                plot: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

}
